/*
 * Public API Surface of angular-simple-lib
 */

export * from './lib/angular-simple-lib.service';
export * from './lib/angular-simple-lib.component';
export * from './lib/angular-simple-lib.module';
